export default [
  {
    value: "0.25",
    label: "+1/4 mi",
  },
  {
    value: "0.5",
    label: "+1/2 mi",
  },
  {
    value: "1",
    label: "+1 mi",
  },
  {
    value: "3",
    label: "+3 mi",
  },
  {
    value: "5",
    label: "+5 mi",
  },
  {
    value: "10",
    label: "+10 mi",
  },
  {
    value: "20",
    label: "+20 mi",
  },
  {
    value: "30",
    label: "+30 mi",
  },
];
